import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getRecentQuestions, getCategories } from '../data';
import {
    gettingCategoriesAction,
    gotCategoriesAction,
    gettingRecentlyAddedAction,
    gotRecentlyAddedAction,
    AppState,
} from '../Store';

import { QuestionList } from '../components/QuestionList';
import { CategoryList } from '../components/CategoryList';
import { SearchButton } from '../components/SearchButton';
import { Title } from '../components/Title';

import searchBackground from '../images/search-bg.png';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const Home = () => {
    const dispatch = useDispatch();
    const loading = useSelector((state: AppState) => state.questions.loading);
    const categories = useSelector((state: AppState) => state.questions.categories);
    const questions = useSelector((state: AppState) => state.questions.recentlyAdded);

    useEffect(() => {
        const doGetCategories = async () => {
            dispatch(gettingCategoriesAction());
            const categories = await getCategories();
            dispatch(gotCategoriesAction(categories));
        };
        doGetCategories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const doGetRecentQuestions = async () => {
            dispatch(gettingRecentlyAddedAction());
            const questions = await getRecentQuestions();
            dispatch(gotRecentlyAddedAction(questions));
        };
        doGetRecentQuestions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Title title="Customer Support" />
            <Box
                sx={{
                    backgroundImage: `url(${searchBackground})`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    height: 300,
                }}
            >
                <SearchButton />
            </Box>
            <Container maxWidth="lg">
                {!loading && <CategoryList data={categories} />}
                <Typography variant="h5" align="center" sx={{ pt: 2 }}>
                    Recent articles
                </Typography>
                {!loading && <QuestionList data={questions} showCategory={true} showLabels={false} />}
            </Container>
        </>
    );
};
